import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from '../../services/modal-dialogs';
import { AssetStatisticsItemArray } from '../../models/ss-api/responses/asset.statistics.item';
import { StatsUsageHistoryChartDialog } from '../stats.usage.history.chart/stats.usage.history.chart.dialog';
import { Router } from '@angular/router';

export interface ITop200DialogModel {
    title: string;
    subTitle: string;
    message: string;
    stats: AssetStatisticsItemArray;
}


@Component({
    selector: 'top200-dialog',
    styleUrls: ['./stats.top200.dialog.css'],
    templateUrl: './stats.top200.dialog.html'
})
export class StatsTop200Dialog extends DialogComponent<ITop200DialogModel, boolean> implements ITop200DialogModel, OnInit {

    title: string;
    subTitle: string;
    message: string;
    stats: AssetStatisticsItemArray;

    constructor(dialogService: DialogService, public router: Router) {
        super(dialogService, router);
    }

    ngOnInit() {

    }

    confirm() {
        // we set dialog result as true on click on confirm button,
        // then we can get dialog result from caller code
        this.result = true;
        this.close();
    }

    ConcatLabel(label: string) {
        let regex = new RegExp(/([^\\]+$)/gm);
        return label.match(regex).splice(0, 1);
    }

    showUsageChartDialog(newItemName: string = 'Placeholder Name') {

        let disposable = this.dialogService.addDialog(StatsUsageHistoryChartDialog, {
            itemName: newItemName,
            message: 'Confirm message'
        });
    }


}
